import {
  createRouter,
  createWebHistory,
} from 'vue-router';
import {
  canSeeSection,
  sections,
} from '@/lib/auth/lighthouseAuth';


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../App.vue'),
      beforeEnter: (to, from, next) => {
        // if a user has authenticated in the past - we redirect to the dashboard.
        // Also, for dev purposes we want to prevent redirecting away from the site for better Dev experience
        if (canSeeSection(sections.support) || window.location.hostname === 'localhost') {
          location.href = '/dashboard';
        } else {
          location.href = 'https://westshorehome.com/';
        }
      },
    },
    {
      path: '/wshHome',
      name: 'wshHome',
      component: () => import('../App.vue'),
      beforeEnter: (to, from, next) => {
        location.href = 'https://westshorehome.com/';
      },
    },

    // routes for single-document signing
    {
      path: '/signing/:documentId/:signerId',
      name: 'sign',
      component: () => import('../views/SigningDocument.vue'),
    },
    {
      path: '/signing/complete',
      name: 'complete',
      component: () => import('../views/SigningComplete.vue'),
    },
    {
      path: '/signing/cancelled',
      name: 'cancelled',
      component: () => import('../views/SigningCancelled.vue'),
    },
    {
      path: '/signing/invalid',
      name: 'invalid',
      component: () => import('../views/SigningInvalid.vue'),
    },
    {
      path: '/signing/done',
      name: 'done',
      component: () => import('../views/SigningDone.vue'),
    },

    // routes for multi-document signing session
    {
      path: '/signing/session/:documentId/:signatoryId',
      name: 'session-sign',
      component: () => import('../views/SigningSession.vue'),
    },
    {
      path: '/signing/session/complete',
      name: 'session-complete',
      component: () => import('../views/SigningComplete.vue'),
    },
    {
      path: '/signing/session/cancelled',
      name: 'session-cancelled',
      component: () => import('../views/SigningCancelled.vue'),
    },
    {
      path: '/signing/session/invalid',
      name: 'session-invalid',
      component: () => import('../views/SigningInvalid.vue'),
    },
    {
      path: '/signing/session/done',
      name: 'session-done',
      component: () => import('../views/SigningDone.vue'),
    },

    {
      path: '/error',
      name: 'error',
      component: () => import('../views/errors/Error.vue'),
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: () => import('../views/errors/Unauthorized.vue'),
    },
    {
      path: '/forbidden',
      name: 'forbidden',
      component: () => import('../views/errors/Forbidden.vue'),
    },
    {
      path: '/notfound',
      name: 'not-found',
      component: () => import('../views/errors/NotFound.vue'),
    },
    {
      path: '/badrequest',
      name: 'bad-request',
      component: () => import('../views/errors/BadRequest.vue'),
    },
    {
      path: '/servererror',
      name: 'server-error',
      component: () => import('../views/errors/ServerError.vue'),
    },
    {
      path: '/:catchAll(.*)',
      name: 'default',
      redirect: '/NotFound',
    },
  ],
});

export default router;
